import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'
import { useSelector } from 'react-redux'

const ServicoNaUnidade = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="SERVIÇO NA UNIDADE" />
                    <CheckContainer>
                    <HeaderVerde texto="Equipe Técnica na Assistência" />
                        <CheckBox texto="Médico Clínico" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Médico Psiquiatra" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Terapia Ocupacional" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Enfermeiro" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Técnico de Enfermagem" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Psicólogo" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Assistente Social" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fisioterapeuta"grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Profissional da Educação Física" grupo="assistencia" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>
                </Caixa>
            )
        }
        return partes
    }
}

export default ServicoNaUnidade